import env from 'react-dotenv'
import Backend from 'i18next-locize-backend'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { DateTime } from 'luxon'
import HttpBackend from 'i18next-http-backend'

const hasLocizeKey = env?.LOCIZE_API_KEY

const locizeOptions = {
  projectId: 'd5a375b7-c706-40ae-8590-0a346d3c48a7',
  apiKey: env?.LOCIZE_API_KEY,
  version: 'latest',
  referenceLng: 'en'
}

const localOptions = {
  // eslint-disable-next-line no-undef
  loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json?lng={{lng}}&{{ns}}`,
  // eslint-disable-next-line no-undef
  addPath: `${process.env.PUBLIC_URL}/locales/add/{{lng}}/{{ns}}`
}

const languages = ['ar', 'de', 'en', 'es', 'es-MX', 'fi', 'fr', 'it', 'he', 'ja', 'ko', 'nb', 'nl', 'sv', 'uk', 'zh-CN', 'zh-Hans', 'zh-Hant', 'zh-TW']

const languageDetector = new LanguageDetector(null, {
  order: ['querystring', 'cookie', 'navigator', 'localStorage', 'sessionStorage', 'htmlTag', 'path', 'subdomain']
})

export const options = {
  debug: false,
  fallbackLng: {
    'zh-CN': ['zh-Hans'],
    'zh-TW': ['zh-Hant'],
    default: ['en']
  },
  supportedLngs: languages,
  nonExplicitSupportedLngs: true,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
    format: (value, format, lng) => {
      if (value instanceof Date) {
        return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime[format])
      }
      return value
    }
  },
  backend: hasLocizeKey ? locizeOptions : localOptions,
  ignoreJSONStructure: true,
  saveMissing: true,
  react: {
    useSuspense: false
  }
}

i18n
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .use(initReactI18next)
  .use(languageDetector)
  .use(hasLocizeKey ? Backend : HttpBackend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector

export default i18n
